<script setup>
import { onMounted } from "vue";

onMounted(() => {
  require("@/assets/js/gst-calculator.js");
});
</script>
<template>
  <main class="seo-calculators upstox-gst-calculator">
    <!-- breadcrumb template -->
    <section class="breadcrumbs-sec">
      <div class="container breadcrumbs-ol">
        <div class="stocks-indices-breadcrumbs_wrap">
          <ol class="stocks-indices-breadcrumbs">
            <li>
              <a href="/">
                <span>Trading </span>
              </a>
            </li>
            <li>
              <a>
                <span>Calculators </span>
              </a>
            </li>
            <li>
              <span>GST Calculator </span>
            </li>
          </ol>
        </div>
      </div>
    </section>
    <!-- end breadcrumb template -->
    <div class="container">
      <h1 class="page-heading fw-300">GST Calculator</h1>
      <h2 class="page-sub-heading">Calculate your GST.</h2>

      <div class="container no-padding-web">
        <div class="row">
          <div class="col-md-6 no-padding">
            <div class="slider-container">
              <form name="calculator">
                <div class="selection">
                  <label class="radio-button"
                    >GST Exclusive
                    <input
                      type="radio"
                      checked=""
                      name="type"
                      value="gstExclusive"
                    />
                    <span class="checkmark"></span>
                  </label>
                  <label class="radio-button"
                    >GST Inclusive
                    <input type="radio" name="type" value="gstInclusive" />
                    <span class="checkmark"></span>
                  </label>
                </div>
                <div class="slider">
                  <div class="slider__row">
                    <h3 class="slider__heading">Total GST</h3>
                    <div class="slider__input">
                      <input
                        type="number"
                        name="totalAmount"
                        value="10000"
                        min="1000"
                        max="10000000"
                        step="500"
                        id="total-amount-input"
                      /><span>₹</span>
                    </div>
                  </div>
                  <input
                    type="range"
                    min="1000"
                    value="10000"
                    max="10000000"
                    id="total-amount-slider"
                    style="
                      position: absolute;
                      width: 1px;
                      height: 1px;
                      overflow: hidden;
                      opacity: 0;
                    "
                  />
                  <div
                    class="rangeslider rangeslider--horizontal"
                    id="js-rangeslider-0"
                  >
                    <div
                      class="rangeslider__fill"
                      style="width: 15.405px"
                    ></div>
                    <div
                      class="rangeslider__handle"
                      style="left: 0.405041px"
                    ></div>
                  </div>
                  <div class="slider__row">
                    <div class="slider__min">₹1,000</div>
                    <div class="slider__max">₹1,00,00,000</div>
                  </div>
                </div>

                <div class="slider">
                  <div class="slider__row">
                    <h3 class="slider__heading">Tax Slab</h3>
                    <div class="slider__input">
                      <input
                        class="number-of-years"
                        type="number"
                        name="returnRate"
                        value="6.5"
                        step="0.1"
                        min="1"
                        max="15"
                        id="return-rate-input"
                      /><span>%</span>
                    </div>
                  </div>
                  <input
                    type="range"
                    min="1"
                    value="6.5"
                    step="0.1"
                    max="30"
                    id="return-rate-slider"
                    style="
                      position: absolute;
                      width: 1px;
                      height: 1px;
                      overflow: hidden;
                      opacity: 0;
                    "
                  />
                  <div
                    class="rangeslider rangeslider--horizontal"
                    id="js-rangeslider-1"
                  >
                    <div
                      class="rangeslider__fill"
                      style="width: 100.345px"
                    ></div>
                    <div
                      class="rangeslider__handle"
                      style="left: 85.3448px"
                    ></div>
                  </div>
                  <div class="slider__row">
                    <div class="slider__min">1 %</div>
                    <div class="slider__max">30%</div>
                  </div>
                </div>
              </form>
            </div>
          </div>

          <div class="col-md-6 no-padding">
            <aside class="calculator-output">
              <h3 class="calculator-output__heading bold fs-20">Total GST</h3>
              <div id="gst-amount" class="calculator-output__amount--large">
                ₹ 650
              </div>

              <h3
                id="gstAmoutText"
                class="calculator-output__heading fs-20 bold"
              >
                Post - GST Amount
              </h3>
              <div
                id="post-gst-amount"
                class="calculator-output__amount--large"
              >
                ₹ 10,650
              </div>

              <a href="https://wa.me/+917092362098" class="cta"
                >Invest Now</a
              >
            </aside>
          </div>
        </div>
      </div>
    </div>

    <!-- Calculator Qna Section -->

    <section class="container calculator-info">
      <h2>What is GST in India?</h2>
      <p></p>
      <p>
        The Goods and Services Tax is an indirect tax that is levied in India
        upon the supply of all goods and services. It is comprehensive. It is
        multi-stage and it is destination based.
      </p>
      <p>
        GST came into being in India on the 1st of July 2017. Almost all
        indirect taxes like central excise duty, VAT, Octroi, Service tax,
        customs duty etc. were replaced by it. It is based on the same
        principles as VAT and is charged on value additions. This being the
        single tax, has made the taxation process of businesses easier. All
        goods and services are divided into five tax rates – 0%, 5%, 12%, 18%
        &amp; 28%, while some products like petrol, alcohol &amp; electricity
        are not taxed under GST. They have individual state taxes.
      </p>
      <p></p>
      <h2>What is a GST calculator?</h2>
      <p></p>
      <p>
        An online calculator, the GST calculator is used to compute the GST
        payable to the Government of India either monthly or quarterly. It is
        very easy to use, and is dynamic as it can be used to calculate for all
        types of users like retailers, wholesalers, buyers and manufacturers.
        The Upstox GST calculator is super easy to understand &amp; use.
      </p>
      <p></p>
      <h2>How to Calculate GST using a GST Calculator?</h2>
      <p></p>
      <p>
        The Upstox GST calculator is a handy, easy to use &amp; dynamic
        calculator that can help calculate the GST as per the net price of good
        or service and the slab it falls under. Follow the steps to calculate
        GST:
      </p>
      <p>
        Step 1: Select whether you are a wholesaler, manufacturer or a buyer.<br />
        Step 2: Enter the Net Price of a good or service.<br />
        Step 3: Select the GST rate that is applicable for said good or
        service.<br />
        Step 4: Click on calculate.
      </p>
      <p>
        The Upstox calculator will display the gross price of product as well as
        CGST &amp; SGST or IGST.
      </p>
      <p></p>
      <h2>What is the GST formula?</h2>
      <p></p>
      <p>When GST is not included and must be calculated to be added on top.</p>
      <p>
        GST Amount = (Net Value of good/service x GST%) / 100<br />
        Hence, Final Price = Net Value of good/service + GST Amount
      </p>
      <p>When GST is already included and reverse GST Amount is required.</p>
      <p>
        GST Amount = Gross Value of good/service – [ Gross Value of good/service
        x {100/(100 + GST%)}]
      </p>
      <p>
        For example, Say a good is net priced at Rs. 5,000, and GST slab to be
        levied is 18%<br />
        GST = (5,000 x 18) / 100<br />
        GST = 900
      </p>
      <p>
        Here, IGST is Rs. 900 or if CGST &amp; SGST is to be levied, it would be
        Rs. 450 each.
      </p>
      <p>
        Similarly, if the gross price of a good is Rs. 5,900, and GST is levied
        at 18%
      </p>
      <p>
        GST = 5,900 – [5,900 x {100/(100 + 18)}]<br />
        GST = 5,900 – [5,900 x 0.84]<br />
        GST = 5,900 – 5,000<br />
        GST = Rs. 900
      </p>
      <p>
        Here, IGST is Rs. 900 or if CGST &amp; SGST is to be levied, it would be
        Rs. 450 each.
      </p>
      <p></p>
      <h2>What is the percentage of GST in India?</h2>
      <p></p>
      <p>The different GST slabs in India are</p>
      <ul style="padding-left: 25px">
        <li style="list-style: disc">0% for milk, bread (necessity items)</li>
        <li style="list-style: disc">0.25% for rough diamonds</li>
        <li style="list-style: disc">3% on gold, silver and such</li>
        <li style="list-style: disc">
          5% for some goods that are fresh or chilled or go through UHT (Ultra
          High Temp) processing
        </li>
        <li style="list-style: disc">
          12% for some goods like plastic beads, notebooks, eyeglasses,
          processed foods etc.
        </li>
        <li style="list-style: disc">
          18% for all services and some goods like electronics, bags, aluminium
          foil etc.
        </li>
        <li style="list-style: disc">
          28% for some items like cars, tobacco, cement, etc.
        </li>
        <li style="list-style: disc">
          NIL rate which is different for 0% and is the slab for exempted goods
          and services
        </li>
      </ul>
      <p></p>
      <h2>How to make calculation of GST in case of reverse charge?</h2>
      <p></p>
      <p>
        Firstly, reverse charge is that mechanism in which the person receiving
        the goods or services is liable to pay the GST instead of the supplier
        of the goods or services. While the recipient will pay GST, the invoice
        of the supplier must mention it in the tax invoice as per the GST law. A
        good example of this is that in the case of Uber, they do not collect
        and pay GST, instead the middlemen, the e-commerce platform managers are
        liable to pay the GST.
      </p>
      <p>
        To calculate the reverse charge, the calculation remains exactly the
        same. Let’s say, a purchase of Rs. 10,000 is made. The buyer will then
        calculate GST (let’s say 18%) on this and has to pay a GST amount of Rs.
        1,800 (IGST) or Rs. 900 (CGST + SGST).
      </p>
      <p></p>
      <h2>What are the benefits of the GST Calculator?</h2>
      <p></p>
      <p>
        The Upstox GST calculator is simple to use and gives results within
        milliseconds. The benefits of using this calculator are:
      </p>
      <p>
        1. It helps in calculating the net and gross amounts for a good or
        service as per the GST rate<br />
        2. It helps in distinguishing between IGST, CGST, SGST and UTGST with
        accurate amounts each<br />
        3. It gives instant results hence, saving time<br />
        4. There is no scope for human error<br />
        5. It is easy and hassle free
      </p>
      <p></p>
      <h2>Example of GST Calculation?</h2>
      <p></p>
      <p>
        Let’s say the net value amount of a good is Rs. 55,000. GST is
        chargeable at 15%, what is the GST amount and Gross value to be paid?
      </p>
      <p>
        GST = (Net Value of good/service x GST%) / 100<br />
        GST = (55,000 x 15) / 100<br />
        GST = Rs. 8,250
      </p>
      <p>
        Hence, Gross Amount = Net Value + GST<br />
        = Rs. 63,250
      </p>
      <p>
        Another example is let’s say the net value amount of a good is Rs.
        2,00,000. GST is chargeable at 18%, what is the GST amount and Gross
        value to be paid?
      </p>
      <p>
        GST = (Net Value of good/service x GST%) / 100<br />
        GST = (2,00,000 x 18) / 100<br />
        GST = Rs. 36,000
      </p>
      <p>
        Hence, Gross Amount = Net Value + GST<br />
        = Rs. 2,36,000
      </p>
      <p>
        Interchangeably, If Gross Value was 2,36,000 and one wanted to find Net
        value of product and GST amount separately, the formula would change to:
      </p>
      <p>
        GST = Gross Value of good/service – [ Gross Value of good/service x
        {100/(100 + GST%)}]<br />
        GST = 2,36,000 – [2,36,000 x {100 / (100 + 18)}]<br />
        GST = 2,36,000 – [2,36,000 x 0.84]<br />
        GST = 2,36,000 – 2,00,000<br />
        GST = Rs. 36,000
      </p>
      <p>
        Hence, Net Amount = Gross Amount – GST<br />
        = Rs. 2,00,000
      </p>
      <p></p>
    </section>

    <!-- Calculator Faqs Section-->

    <section class="container calculator_help_section">
      <h2 class="fs-28 bold help_here">Frequently Asked Questions</h2>
      <div class="smooth-font">
        <div
          class="panel-group"
          id="accordion"
          role="tablist"
          aria-multiselectable="true"
        >
          <div class="panel panel-default">
            <div class="panel-heading" id="headingTwo">
              <h3 class="panel-title">
                <span class="panel-trigger" val="#collapse1">
                  <span class="expand_icon dashicons-plus"></span>
                  <span>How to Calculate GST in Excel in India?</span>
                </span>
              </h3>
            </div>
            <div id="collapse1" class="panel-collapse collapse">
              <div class="panel-body visible">
                <p>Firstly, start by preparing a data table containing:</p>
                <ul style="padding-left: 25px">
                  <li style="list-style: disc">
                    Net Value (let’s say in box B3)
                  </li>
                  <li style="list-style: disc">
                    GST Amount (let’s say in box B4)
                  </li>
                  <li style="list-style: disc">
                    GST rate (let’s say in box B5)
                  </li>
                  <li style="list-style: disc">
                    Gross Amount (let’s say in box B6)
                  </li>
                </ul>
                <p>
                  If you wish to take out GST Amount, box B4 formula will be B3
                  * B5 (make sure B5 has % sign)<br />
                  If you wish to take out Gross Amount, box B6 formula will be
                  B3 + B4
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="smooth-font">
        <div
          class="panel-group"
          id="accordion"
          role="tablist"
          aria-multiselectable="true"
        >
          <div class="panel panel-default">
            <div class="panel-heading" id="headingTwo">
              <h3 class="panel-title">
                <span class="panel-trigger" val="#collapse2">
                  <span class="expand_icon dashicons-plus"></span>
                  <span>Can GST be paid online?</span>
                </span>
              </h3>
            </div>
            <div id="collapse2" class="panel-collapse collapse">
              <div class="panel-body visible">
                <p>
                  GST is paid by the final buyer to the seller at point of sale,
                  along with the rest of the net amount. The Indian Government
                  has an online portal – www.gstin.gov that is used by all
                  businesses, i.e., Manufacturers, Sellers as well as service
                  providers and the portal can be accessed through their
                  personal GST numbers. They can make the payment online on the
                  portal directly on a monthly or quarterly basis. Final buyers,
                  without a GST registered number cannot access this portal.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="smooth-font">
        <div
          class="panel-group"
          id="accordion"
          role="tablist"
          aria-multiselectable="true"
        >
          <div class="panel panel-default">
            <div class="panel-heading" id="headingTwo">
              <h3 class="panel-title">
                <span class="panel-trigger" val="#collapse3">
                  <span class="expand_icon dashicons-plus"></span>
                  <span>What are the types of GST?</span>
                </span>
              </h3>
            </div>
            <div id="collapse3" class="panel-collapse collapse">
              <div class="panel-body visible">
                <p>
                  GST in India benefits both the State/UT &amp; Central
                  Government, hence, making it a dual tax system. As per this,
                  there are 4 types of GST –
                </p>
                <p>
                  1. IGST – IGST stands for Integrated Goods and Services Tax
                  and is collected wholly by the Central Government of India on
                  inter-state sale of goods and services.<br />
                  2. SGST – SGST stands for State Goods and Services Tax and is
                  levied by the State Government of the state within which the
                  sale or purchase of goods and services has taken place.<br />
                  3. CGST – CGST stands for Central Goods &amp; Services Tax. It
                  is levied by the Central Government of India on all the
                  intra-state supply of goods and services.<br />
                  4. UTGST – UTGST stands for Union Territory Goods and Services
                  Tax and is levied by the Union Territories Government within
                  which the sale or purchase of goods and services has taken
                  place.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="smooth-font">
        <div
          class="panel-group"
          id="accordion"
          role="tablist"
          aria-multiselectable="true"
        >
          <div class="panel panel-default">
            <div class="panel-heading" id="headingTwo">
              <h3 class="panel-title">
                <span class="panel-trigger" val="#collapse4">
                  <span class="expand_icon dashicons-plus"></span>
                  <span>What is IGST ?</span>
                </span>
              </h3>
            </div>
            <div id="collapse4" class="panel-collapse collapse">
              <div class="panel-body visible">
                <p>
                  IGST stands for Integrated Goods and Services Tax and is
                  collected wholly by the Central Government of India on
                  inter-state sale of goods and services.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="smooth-font">
        <div
          class="panel-group"
          id="accordion"
          role="tablist"
          aria-multiselectable="true"
        >
          <div class="panel panel-default">
            <div class="panel-heading" id="headingTwo">
              <h3 class="panel-title">
                <span class="panel-trigger" val="#collapse5">
                  <span class="expand_icon dashicons-plus"></span>
                  <span>What is SGST ?</span>
                </span>
              </h3>
            </div>
            <div id="collapse5" class="panel-collapse collapse">
              <div class="panel-body visible">
                <p>
                  SGST stands for State Goods and Services Tax and is levied by
                  the State Government of the state within which the sale or
                  purchase of goods and services has taken place.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="smooth-font">
        <div
          class="panel-group"
          id="accordion"
          role="tablist"
          aria-multiselectable="true"
        >
          <div class="panel panel-default">
            <div class="panel-heading" id="headingTwo">
              <h3 class="panel-title">
                <span class="panel-trigger" val="#collapse6">
                  <span class="expand_icon dashicons-plus"></span>
                  <span>What is CGST ?</span>
                </span>
              </h3>
            </div>
            <div id="collapse6" class="panel-collapse collapse">
              <div class="panel-body visible">
                <p>
                  CGST stands for Central Goods &amp; Services Tax. It is levied
                  by the Central Government of India on all the intra-state
                  supply of goods and services.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="smooth-font">
        <div
          class="panel-group"
          id="accordion"
          role="tablist"
          aria-multiselectable="true"
        >
          <div class="panel panel-default">
            <div class="panel-heading" id="headingTwo">
              <h3 class="panel-title">
                <span class="panel-trigger" val="#collapse7">
                  <span class="expand_icon dashicons-plus"></span>
                  <span>What is UTGST ?</span>
                </span>
              </h3>
            </div>
            <div id="collapse7" class="panel-collapse collapse">
              <div class="panel-body visible">
                <p>
                  UTGST stands for Union Territory Goods and Services Tax and is
                  levied by the Union Territories Government within which the
                  sale or purchase of goods and services has taken place.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="smooth-font">
        <div
          class="panel-group"
          id="accordion"
          role="tablist"
          aria-multiselectable="true"
        >
          <div class="panel panel-default">
            <div class="panel-heading" id="headingTwo">
              <h3 class="panel-title">
                <span class="panel-trigger" val="#collapse8">
                  <span class="expand_icon dashicons-plus"></span>
                  <span>What are the slabs of GST?</span>
                </span>
              </h3>
            </div>
            <div id="collapse8" class="panel-collapse collapse">
              <div class="panel-body visible">
                <p>The different GST slabs in India are</p>
                <ul style="padding-left: 25px">
                  <li style="list-style: disc">
                    0% for milk, bread (necessity items)
                  </li>
                  <li style="list-style: disc">0.25% for rough diamonds</li>
                  <li style="list-style: disc">3% on gold, silver and such</li>
                  <li style="list-style: disc">5% for some goods</li>
                  <li style="list-style: disc">12% for some goods</li>
                  <li style="list-style: disc">
                    18% for all services and some goods
                  </li>
                  <li style="list-style: disc">
                    28% for some items like cars, tobacco, cement, etc.
                  </li>
                  <li style="list-style: disc">
                    NIL rate which is different for 0% and is the slab for
                    exempted goods and services
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="smooth-font">
        <div
          class="panel-group"
          id="accordion"
          role="tablist"
          aria-multiselectable="true"
        >
          <div class="panel panel-default">
            <div class="panel-heading" id="headingTwo">
              <h3 class="panel-title">
                <span class="panel-trigger" val="#collapse9">
                  <span class="expand_icon dashicons-plus"></span>
                  <span>Is GST direct tax?</span>
                </span>
              </h3>
            </div>
            <div id="collapse9" class="panel-collapse collapse">
              <div class="panel-body visible">
                <p>
                  No, GST is an indirect tax levied on the sale of goods and
                  services by the Government of India.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="smooth-font">
        <div
          class="panel-group"
          id="accordion"
          role="tablist"
          aria-multiselectable="true"
        >
          <div class="panel panel-default">
            <div class="panel-heading" id="headingTwo">
              <h3 class="panel-title">
                <span class="panel-trigger" val="#collapse10">
                  <span class="expand_icon dashicons-plus"></span>
                  <span>What is levy and collection of GST?</span>
                </span>
              </h3>
            </div>
            <div id="collapse10" class="panel-collapse collapse">
              <div class="panel-body visible">
                <p>
                  Levy means the import &amp; assessment of the tax which is
                  done to compute the amount of liability arising under the GST
                  law.
                </p>
                <p>
                  Collection of the tax is the process of collecting the
                  liability amount as prescribed by the law.
                </p>
                <p>
                  These two are governed by Section 9 of the CGST/SGST Act &amp;
                  Section 5 of the IGST Act.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="smooth-font">
        <div
          class="panel-group"
          id="accordion"
          role="tablist"
          aria-multiselectable="true"
        >
          <div class="panel panel-default">
            <div class="panel-heading" id="headingTwo">
              <h3 class="panel-title">
                <span class="panel-trigger" val="#collapse11">
                  <span class="expand_icon dashicons-plus"></span>
                  <span>How is GST collected in India?</span>
                </span>
              </h3>
            </div>
            <div id="collapse11" class="panel-collapse collapse">
              <div class="panel-body visible">
                <p>
                  GST is paid by the final buyer to the seller at point of sale,
                  along with the rest of the net amount. The Indian Government
                  has an online portal – www.gstin.gov that is used by all
                  businesses, i.e., Manufacturers, Sellers as well as service
                  providers and the portal can be accessed through their
                  personal GST numbers. They can make the payment online on the
                  portal directly on a monthly or quarterly basis. Final buyers,
                  without a GST registered number cannot access this portal.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Similar Calculator Section-->
    <!-- text start similar-->
    <section class="similar_section">
      <div class="container">
        <div class="heading-wrap">
          <h2 class="fs-28 bold help_here">Similar Calculator</h2>
          <button class="similar-btn btn-all">View all</button>
          <button class="similar-btn btn-less" style="display: none">
            View less
          </button>
        </div>
        <div class="smooth-wrap">
          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3><a> Brokerage Calculator</a></h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3><a> Margin Calculator</a></h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3><a> Mutual Fund Returns Calculator</a></h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3><a> SIP Calculator</a></h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3><a> NPV Calculator</a></h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3><a> Future Value Calculator</a></h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3><a> SWP Calculator</a></h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3><a> ELSS Calculator</a></h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3><a> Option Value Calculator</a></h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3><a> NPS Calculator</a></h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3><a> PPF Calculator</a></h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3><a> Compound Annual Growth Rate Calculator</a></h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3><a> National Savings Certificate Calculator</a></h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3><a> Sukanya Samriddhi Yojana Calculator</a></h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3><a> Compound Interest Calculator</a></h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3><a> Atal Pension Yojana Calculator</a></h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3><a> Gratuity calculator</a></h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3><a> Simple Interest Calculator</a></h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3><a> Fixed Deposit Calculator</a></h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3><a> HRA Calculator</a></h3>
          </div>
        </div>
      </div>
    </section>

    <!-- Calculator Disclaimer Section -->
    <section class="container calculator-disclaimer">
      <div>
        <p>
          Disclaimer:<br />
          This calculator is meant to be used for indicative purposes only. It
          is designed to assist you in determining the appropriate amount of
          prospective investments. This calculator alone is not sufficient and
          shouldn’t be used for the development or implementation of any
          investment strategy. Upstox does not take the responsibility/liability
          nor does it undertake the authenticity of the figures calculated
          therein. Upstox makes no warranty about the accuracy of the
          calculators/reckoners. The examples do not claim to represent the
          performance of any security or investments. In view of the individual
          nature of tax consequences, each investor is advised to consult
          his/her own professional tax advisor before making any investment
          decisions on the basis of the results provided through the use of this
          calculator.
        </p>
      </div>
    </section>
  </main>
</template>
<style scoped>
</style>
